export default __webpack_public_path__ + "static/media/dieppe8.4ebc1ac0.jpg";